import { parseDetails } from "./notificationText";

/**
 * The page a discipline notification opens. The backend sends the page key
 * and the complaint's id (discipline pages are opened by the complaint);
 * appeal and accused pages also need whether the complaint is regional,
 * which the notification's codes carry.
 */
const ROUTES: Record<string, { path: (id: string) => string; regional?: boolean }> = {
  ComplaintReception: { path: (id) => `/complaint-request/${id}` },
  AppealRequest: { path: (id) => `/appeal-request/${id}`, regional: true },
  AccusedAppeal: { path: (id) => `/accused-complaint/${id}`, regional: true },
  CourtAppeal: { path: (id) => `/court-appeal/${id}` },
  AdvocateComplaint: { path: (id) => `/advocate-complaint/${id}` },
  AdvocateAppeal: { path: (id) => `/advocate-appeal/${id}`, regional: true },
  AdvocateAccusedAppeal: { path: (id) => `/advocate-accused-appeal/${id}`, regional: true },
  AdvocateCourtAppeal: { path: (id) => `/advocate-court-appeal/${id}` },
};

export const notificationRoute = (n: any): [string, any?] | undefined => {
  const model = n?.model_name || String(n?.type || "").split(".").pop();
  const route = model && ROUTES[model];
  if (!route || !n?.object_id) return undefined;
  const path = route.path(String(n.object_id));
  return route.regional ? [path, { is_regional: !!parseDetails(n.status)?.regional }] : [path];
};
